import { useEffect, useRef } from "react";
import { toFarsiNumber } from "../../../custom/helpers";
import "../../../styles/Challenges.css";

const stateLabels = {
  completed: "تکمیل شده",
  today: "امروز، ثبت نشده",
  missed: "از دست رفته",
  upcoming: "روز آینده",
};

function ChallengeDayScroller({ days, focusDayNumber }) {
  const rowRef = useRef(null);
  const bulletRefs = useRef({});

  useEffect(() => {
    const target = bulletRefs.current[focusDayNumber];
    if (target && rowRef.current) {
      target.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focusDayNumber, days?.length]);

  if (!days || days.length === 0) return null;

  return (
    <div className="challengeDayRow" role="list" ref={rowRef}>
      {days.map((day) => (
        <div
          key={day.day_number}
          ref={(el) => (bulletRefs.current[day.day_number] = el)}
          role="listitem"
          aria-label={`روز ${day.day_number}، ${stateLabels[day.state] || day.state}`}
          className={`challengeDayBullet challengeDayBullet-${day.state}`}
        >
          {day.state === "completed" ? (
            <span className="icon-icondone" aria-hidden="true"></span>
          ) : (
            toFarsiNumber(day.day_number)
          )}
        </div>
      ))}
    </div>
  );
}

export default ChallengeDayScroller;
